import { cloneDeep, isEmpty } from 'lodash'
import { storageRef } from '../../../config/firebase'
import { updateDoc } from '../../../utils/db/updateDoc'

export const deletePhoto = ({
  photoIndex,
  photos,
  setPhotos,
  projectId,
  docPath = 'products',
  propName,
  persistDelete = true,
}) => {
  const photosClone = cloneDeep(photos)
  const photo = photosClone[photoIndex]

  photosClone.splice(photoIndex, 1)
  if (photo.isAvatar && !isEmpty(photosClone)) {
    photosClone[0].isAvatar = true
  }

  if (!photo.storagePath) {
    setPhotos(photosClone)
    return
  }

  const removeFromStorage = () =>
    storageRef.child(`${photo.storagePath}/${projectId}/${photo.fileName}.${photo.fileExt}`).delete()

  if (!persistDelete) {
    removeFromStorage()
      .catch((error) => console.log('deletePhoto storage cleanup:', error))
      .finally(() => setPhotos(photosClone))
    return
  }

  removeFromStorage()
    .then(() =>
      updateDoc({
        path: docPath,
        docId: projectId,
        data: { [propName]: photosClone.filter((p) => !p.needUpload) },
      })
    )
    .then(() => setPhotos(photosClone))
    .catch((e) => console.log('🚀 ~ file: deletePhoto.js ~ line 29 ~ deletePhoto ~ e', e))
}

export default deletePhoto
